import { Injectable } from '@angular/core';
import { AnalyticsType, FPObjectProperties } from './types-t';

@Injectable({
  providedIn: 'root'
})
export class TrackingProvider {

  constructor() { }

  /**
  * Call native Google Analytics function
  */
  gtagWrapper(...args: any[]) {
    try {
      (window as any).gtag(...args.filter(x => x !== undefined));
    } catch (err) {
      console.error('Error al llamar a gtag: ', err);
    }
  }

  /**
  * Call native Facebook Pixel function
  */
  fbqWrapper(event: string, properties?: FPObjectProperties) {
    try {
      if (properties) {
        (window as any).fbq('track', event, properties);
      } else {
        (window as any).fbq('track', event);
      }
    } catch (err) {
      console.error('Error al llamar a fbq: ', err);
    }
  }

  /**
   * Send a page view event. This is the same as
   * @param path /home
   * @param title Homepage
   * @param location '{ page_location }'
  */
  pageView(analyticsType: AnalyticsType, title?: string, location?: string/* , options?: Object */) {
    try {
      switch (analyticsType) {
        case AnalyticsType.GOOGLE_ANALYTICS:
          this.gtagWrapper('event', 'page_view', {
            page_title: title,
            page_location: location || window.document.location.href,
          });
          break;
        case AnalyticsType.FACEBOOK_PIXEL:
          this.fbqWrapper('PageView');
          break;
        default:
          throw new Error('Analytics type no definido');
      }
    } catch (error) {
      console.error('Error al enviar evento de pageview: ', error);
    }
  }

  /**
   * Send a promotion_share event
   */
  trackPromotionShare(analyticsType: AnalyticsType) {
    try {
      switch (analyticsType) {
        case AnalyticsType.GOOGLE_ANALYTICS:
          this.gtagWrapper('event', 'promotion_share', {
            event_category: 'Promotion',
            event_label: 'Promotion Share'
          });
          break;
        case AnalyticsType.FACEBOOK_PIXEL:
          this.fbqWrapper('promotion_share');
          break;
        default:
          throw new Error('Analytics type no definido');
      }
    } catch (error) {
      console.error('Error al enviar evento de promotion_share: ', error);
    }
  }

  /**
   * Send a promotion_course_selected event
   */
  trackPromotionCourseSelected(analyticsType: AnalyticsType) {
    try {
      switch (analyticsType) {
        case AnalyticsType.GOOGLE_ANALYTICS:
          this.gtagWrapper('event', 'promotion_course_selected', {
            event_category: 'Promotion',
            event_label: 'Promotion Course Selected'
          });
          break;
        case AnalyticsType.FACEBOOK_PIXEL:
          this.fbqWrapper('promotion_course_selected');
          break;
        default:
          throw new Error('Analytics type no definido');
      }
    } catch (error) {
      console.error('Error al enviar evento de promotion_course_selected: ', error);
    }
  }
}
